import api from './api';

const BASE_PATH = '/questions';

/**
 * Cliente da API de Questions.
 * Usado pelo Banco de Questões (GATE de seleção + listagem filtrada).
 */
export const questionsApi = {
  // GET /api/v1/questions/count?filter[ineditas]=true&filter[etapa][]=ano_9_ef...
  // Resposta: { count: N }
  count: filters => {
    const params = buildFilterParams(filters);
    return api.get(`${BASE_PATH}/count`, { params });
  },

  // GET /api/v1/questions?filter[...]&page[number]=1&page[size]=25
  index: ({ filters = {}, page = 1, perPage = 25 } = {}) => {
    const params = { ...buildFilterParams(filters), 'page[number]': page, 'page[size]': perPage };
    return api.get(BASE_PATH, { params });
  },

  // GET /api/v1/questions/facets?filter[...]&taxonomy_option_ids[]=..&descritor_option_ids[]=..
  // Resposta: { ineditas:{true,false}, etapa:{...}, usadas_em:{...}, taxonomias:{id:n}, descritores:{id:n} }
  // Contagem por opção de cada dimensão (faceted), pros pills do filtro.
  facets: ({ filters = {}, taxonomyOptionIds = [], descritorOptionIds = [] } = {}) => {
    const params = buildFilterParams(filters);
    taxonomyOptionIds.forEach((id, i) => {
      params[`taxonomy_option_ids[${i}]`] = id;
    });
    descritorOptionIds.forEach((id, i) => {
      params[`descritor_option_ids[${i}]`] = id;
    });
    return api.get(`${BASE_PATH}/facets`, { params });
  },

  // GET /api/v1/questions/:id
  show: id => api.get(`${BASE_PATH}/${id}`)
};

// Serializa { ineditas: 'true', etapa: ['ano_9_ef'], 'taxonomies.id': [1,2] }
// em { 'filter[ineditas]': 'true', 'filter[etapa][0]': 'ano_9_ef', ... }
function buildFilterParams(filters) {
  const out = {};
  Object.entries(filters || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value)) {
      if (value.length === 0) return;
      value.forEach((v, i) => {
        out[`filter[${key}][${i}]`] = v;
      });
    } else {
      out[`filter[${key}]`] = value;
    }
  });
  return out;
}
